import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, ToastController } from '@ionic/angular';
import { GlobalService } from 'src/app/global.config';
import { PointInterest } from 'src/app/model/data-managemnt';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { LoadingService } from 'src/app/utils/loading/loadingService';
import { DataManagementService } from '../data-management.service';
import { PointInteretService } from './point-interet.service';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import * as L from 'leaflet';

@Component({
  selector: 'app-point-interet',
  templateUrl: './point-interet.component.html',
  styleUrls: ['./point-interet.component.scss'],
})
export class PointInteretComponent implements OnInit {

  @Input() latPoi: number;
  @Input() lngPoi: number;
  @Input() adresse: string;

  poi: PointInterest = new PointInterest();
  imagesPOIDir = this.globalService.getimagesPOIDir();
  isLoadingAddress = false;

  typePois = [
    { "name": "Marqueur Standard",   "imageUri": "marker1.png",  "imagesrc": this.imagesPOIDir + "marker1.png" },
    { "name": "Marqueur Important",  "imageUri": "marker2.png",  "imagesrc": this.imagesPOIDir + "marker2.png" },
    { "name": "Marqueur Spécial",    "imageUri": "marker3.png",  "imagesrc": this.imagesPOIDir + "marker3.png" },
    { "name": "Marqueur Commercial", "imageUri": "marker4.png",  "imagesrc": this.imagesPOIDir + "marker4.png" },
    { "name": "Marqueur Résidentiel","imageUri": "marker5.png",  "imagesrc": this.imagesPOIDir + "marker5.png" },
    { "name": "Marqueur Industriel", "imageUri": "marker6.png",  "imagesrc": this.imagesPOIDir + "marker6.png" },
    { "name": "Marqueur Service",    "imageUri": "marker7.png",  "imagesrc": this.imagesPOIDir + "marker7.png" },
    { "name": "Marqueur Urgence",    "imageUri": "marker8.png",  "imagesrc": this.imagesPOIDir + "marker8.png" },
    { "name": "Marqueur Temporaire", "imageUri": "marker9.png",  "imagesrc": this.imagesPOIDir + "marker9.png" },
    { "name": "Marqueur Personnel",  "imageUri": "marker10.png", "imagesrc": this.imagesPOIDir + "marker10.png" },
    { "name": "Marqueur Custom",     "imageUri": "marker11.png", "imagesrc": this.imagesPOIDir + "marker11.png" },
    { "name": "Drapeau Rouge",       "imageUri": "flag1.png",    "imagesrc": this.imagesPOIDir + "flag1.png" },
    { "name": "Drapeau Vert",        "imageUri": "flag2.png",    "imagesrc": this.imagesPOIDir + "flag2.png" },
    { "name": "Maison Simple",       "imageUri": "house1.png",   "imagesrc": this.imagesPOIDir + "house1.png" },
    { "name": "Maison Moderne",      "imageUri": "house2.png",   "imagesrc": this.imagesPOIDir + "house2.png" },
  ];

  constructor(
    private poiService: PointInteretService,
    private popoverController: PopoverController,
    public geocodingService: GeocodingService,
    private globalService: GlobalService,
    private dataManagementService: DataManagementService,
    private loadingService: LoadingService,
    private toastController: ToastController,
    private mapService: MapService
  ) {}

  ngOnInit() {
    this.initializePOI();
    this.loadingService.setLoading(false);
  }

  private initializePOI() {
    this.poi.coordinate.lat = this.latPoi;
    this.poi.coordinate.lng = this.lngPoi;
    this.poi.imageUri = 'marker1.png';
    this.poi.ray = 100;
    this.poi.address = this.adresse;

    if (this.latPoi && this.lngPoi) {
      this.getAdresse(this.latPoi, this.lngPoi, 17);
    }
  }

  getAdresse(lat: number, lng: number, zoom: number) {
    this.isLoadingAddress = true;

    this.geocodingService.inverseGeoconding(lat, lng, zoom).subscribe(
      res => {
        this.poi.address = res.display_name;
        this.isLoadingAddress = false;
      },
      error => {
        console.error('Erreur lors de la récupération de l\'adresse:', error);
        this.isLoadingAddress = false;
        this.showToast('Impossible de récupérer l\'adresse automatiquement', 'warning');
      }
    );
  }

  loadPoiImages() {
    setTimeout(() => {
      const selectPopover = document.querySelector('ion-popover.select-popover');
      if (selectPopover) {
        selectPopover.classList.add('poi-select-popover');
      }

      const radios = document.getElementsByClassName('alert-radio-label');
      for (let index = 0; index < radios.length && index < this.typePois.length; index++) {
        const radioLabel = radios[index] as HTMLElement;

        const existingImg = radioLabel.querySelector('img');
        if (existingImg) {
          existingImg.remove();
        }

        const img = document.createElement('img');
        img.src = this.typePois[index].imagesrc;
        img.style.width = '30px';
        img.style.height = '30px';
        img.style.borderRadius = '6px';
        img.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)';

        radioLabel.appendChild(img);
        radioLabel.style.fontSize = '15px';
        radioLabel.style.display = 'flex';
        radioLabel.style.alignItems = 'center';
        radioLabel.style.justifyContent = 'space-between';
        radioLabel.style.padding = '16px';
      }
    }, 200);
  }

  async ajouterPointInteret(poi: PointInterest) {
    if (!this.validatePOI(poi)) {
      this.showToast('Veuillez remplir tous les champs obligatoires', 'warning');
      return;
    }

    try {
      await this.loadingService.setLoading(true);

      const response = await this.poiService.ajouterPointInteret(poi).toPromise();

      // Add to local data
      this.dataManagementService.pointInterests.push(poi);

      // ── Create the marker on the map immediately ──
      if (this.mapService.map) {

        // Build the icon using the selected image
        const icon = L.icon({
          iconUrl: this.imagesPOIDir + poi.imageUri,
          iconSize: [36, 36],
          iconAnchor: [18, 36],
          popupAnchor: [0, -36]
        });

        // Register through the service so the POI eye toggle
        // (removeMarkersFromMap) can remove this marker too.
        const marker = L.marker(
          [poi.coordinate.lat, poi.coordinate.lng],
          { icon, riseOnHover: true }
        );
        this.mapService.addMarker(marker);

        // Add a popup with the POI name and address
        marker.bindPopup(`
        <div style="text-align:center; min-width:140px;">
          <img src="${this.imagesPOIDir + poi.imageUri}"
               style="width:28px;height:28px;margin-bottom:6px;"/>
          <br/>
          <b style="color:#226597;">${poi.name}</b>
          <br/>
          <small style="color:#666;">${poi.address}</small>
        </div>
      `);

        // Fly to the new point
        this.mapService.map.flyTo(
          [poi.coordinate.lat, poi.coordinate.lng],
          16,
          { duration: 1.2 }
        );

        // Drop animation after flyTo finishes
        setTimeout(() => {
          const el = marker.getElement();
          if (el) {
            el.classList.add('poi-drop');
            setTimeout(() => el.classList.remove('poi-drop'), 600);
          }
        }, 1300);
      }
      // ─────────────────────────────────────────────────

      this.showToast('Point d\'intérêt ajouté avec succès !', 'success');

      this.popoverController.dismiss({
        success: true,
        poi: poi
      });

    } catch (error) {
      console.error('Erreur lors de l\'ajout du POI:', error);
      this.showToast('Erreur lors de l\'ajout du point d\'intérêt', 'danger');
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  private validatePOI(poi: PointInterest): boolean {
    return !!(
      poi.name?.trim() &&
      poi.address?.trim() &&
      poi.imageUri &&
      poi.coordinate?.lat &&
      poi.coordinate?.lng &&
      poi.ray > 0
    );
  }

  private async showToast(message: string, color: 'success' | 'warning' | 'danger') {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
      color: 'light',          // always white background
      cssClass: 'poi-toast',   // for blue text styling
      buttons: [
        {
          text: 'Fermer',
          role: 'cancel'
        }
      ]
    });

    await toast.present();
  }

  getSelectedIconSrc(): string {
    if (!this.poi.imageUri) return '';
    return this.imagesPOIDir + this.poi.imageUri;
  }

  onCoordinateChange() {
    if (this.poi.coordinate.lat && this.poi.coordinate.lng) {
      this.getAdresse(this.poi.coordinate.lat, this.poi.coordinate.lng, 17);
    }
  }
}
